import { Injectable } from "@angular/core";
import { FieldSchema, MC_FIELDS_VALIDATION_NAME, MCFieldTypesService, Regex, Validation } from "@maslul/common-services";

@Injectable({
    providedIn: 'root'
})
export class FieldsValidationService {

    constructor(
        private fieldTypesService: MCFieldTypesService
    ) {

    }


    getAllCustomValidationField(fieldSchema: FieldSchema): Validation[] {
        const isLinkFormat: boolean = this.isLinkFormat(fieldSchema.pattern);
        if (this.fieldTypesService.isTextInput(fieldSchema.type) && !isLinkFormat) {
            const forbiddenCharsValidation = { name: MC_FIELDS_VALIDATION_NAME.forbiddenChars, params: null } as unknown as Validation;
            if (!fieldSchema.validation.find(x => x.name == forbiddenCharsValidation.name)) {
                fieldSchema.validation.push(forbiddenCharsValidation);
            }
        }

        return fieldSchema.validation;
    }

    isLinkFormat(pattern: string): boolean {
        let regexObjectFromString = new RegExp("");
        if (pattern) {
            regexObjectFromString = new RegExp(pattern);
        }
        const areFunctionallyEqual =
            regexObjectFromString.source === Regex.linkFormat.source &&
            regexObjectFromString.flags === Regex.linkFormat.flags;
        return areFunctionallyEqual;
    }


}

